module.exports = __webpack_public_path__ + "static/sour-cream-onion-md-e108a7a2d2b6c0573d596df702f8eb47.png";